'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zarm = require('zarm');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = require('@iyunbao/utils');

var _toast = require('../../toast');

var _toast2 = _interopRequireDefault(_toast);

var _fetch = require('../../utils/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AntiBrush = function (_PureComponent) {
  _inherits(AntiBrush, _PureComponent);

  function AntiBrush(props) {
    _classCallCheck(this, AntiBrush);

    var _this = _possibleConstructorReturn(this, (AntiBrush.__proto__ || Object.getPrototypeOf(AntiBrush)).call(this, props));

    _this.loadJS = function () {
      return new Promise(function (resolve) {
        if (typeof ClickIdentifyControl !== 'undefined') {
          resolve();
          return false;
        }

        _utils.load.js('https://af.zhongan.io/dunkey.js', function () {
          _utils.load.css('https://af.zhongan.io/antiSlider.min.css');
          _utils.load.js('https://af.zhongan.io/antiSlider.min.js', function () {
            resolve();
          });
        });
      });
    };

    _this.ceate = function () {
      var onClose = _this.props.onClose;
      var sId = _this.props.sId;

      var reg = new RegExp('^(.+)#(.+)$');
      var env = (0, _config.getEnv)();

      // 目前只有测试和生产环境
      if (!['dev', 'pre'].indexOf(env)) {
        env = 'test';
      }

      // 添加环境，方便开启自动化测试
      if (reg.test(sId)) {
        sId = sId.replace(reg, '$1#' + env + '#$2');
      }

      _this.loadJS().then(function () {
        _this.antiSlider = new window.ClickIdentifyControl({
          container: '#anti-slider', // 必填 容器id
          sId: sId, // 必填 埋点场景ID
          host: _config2.default.URL.af, // https://test-af.zhongan.io  或者 https://af.zhongan.io
          placeholdLabel: '智能检测中', // 可选， loading时显示内容 可以根据业务场景更改内容
          onSuccess: function onSuccess(did, token, sid) {
            _this.verify({ did: did, token: token, sid: sid });
            onClose();
          },
          onFail: function onFail() {
            // this.antiSlider.startAnalyze();
          },
          onCloseDialog: function onCloseDialog() {
            onClose();
          },
          onDunkeyLoad: function onDunkeyLoad() {
            _this.antiSlider.startAnalyze();
          }
        });
      });
    };

    _this.verify = function (params) {
      var _this$props = _this.props,
          bizType = _this$props.bizType,
          data = _this$props.data,
          sTokenId = _this$props.sTokenId,
          onSuccess = _this$props.onSuccess,
          onClose = _this$props.onClose;


      _fetch2.default.fetch({
        path: '/facilities/open/v1/common/security/af/ticket',
        server: 'api',
        method: 'POST',
        data: _extends({}, params, {
          bizType: bizType,
          data: data,
          sTokenId: sTokenId
        })
      }).then(function (_ref) {
        var code = _ref.code,
            result = _ref.result,
            message = _ref.message;

        if (+code === 0 && result) {
          onSuccess(result.ticket, data);
        } else {
          onClose && onClose();
          message && _toast2.default.warning(message);
        }
      }).catch(function () {
        onClose && onClose();
      });
    };

    _this.state = {};

    _this.prefixClsModal = 'cui-modal';

    _this.ceate();
    return _this;
  }

  _createClass(AntiBrush, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          onClose = _props.onClose,
          visible = _props.visible;


      var cls = (0, _classnames3.default)(_defineProperty({
        'ui-anti-brush-modal': true
      }, className, !!className));

      return _react2.default.createElement(
        _zarm.Modal,
        {
          shape: 'radius',
          width: '85%',
          title: '\u9A8C\u8BC1\u7801',
          visible: visible,
          prefixCls: 'cui-modal',
          className: cls,
          closable: true,
          maskClosable: true,
          onCancel: function onCancel() {
            return onClose();
          }
        },
        _react2.default.createElement('div', { id: 'anti-slider' })
      );
    }
  }]);

  return AntiBrush;
}(_react.PureComponent);

AntiBrush.defaultProps = {
  className: '',
  data: '',
  bizType: '',
  sTokenId: '',
  sId: '',
  visible: true,
  onSuccess: function onSuccess() {},
  onClose: function onClose() {}
};
AntiBrush.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.string,
  bizType: _propTypes2.default.string,
  sTokenId: _propTypes2.default.string,
  sId: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  onSuccess: _propTypes2.default.func,
  onClose: _propTypes2.default.func
};
exports.default = AntiBrush;